import { SET_PAGE_INFO } from "../actions/pageInfo";

const initialState = {
    type: "",
    id: "",
    title: "",
};

export default function setPageInfo(state = initialState, action) {
    switch (action.type) {
        case SET_PAGE_INFO:
            const { type, id, title, parentTitle } = action.pageInfo;
            return {
                ...state,
                type,
                id,
                title,
                parentTitle,
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/pageInfo.js